import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';

export const useConnectedProviders = () => {
  return new URLSearchParams(window.location.search).get(TinkLinkUrlParameter.CONNECTED_PROVIDERS);
};

export const useMultiBankingUser = () => {
  return new URLSearchParams(window.location.search).get(TinkLinkUrlParameter.MULTIBANKING_USER);
};

export const resetMultiBankingSession = () => {
  const search = new URLSearchParams(window.location.search);
  search.delete(TinkLinkUrlParameter.CONNECTED_PROVIDERS);
  search.delete(TinkLinkUrlParameter.MULTIBANKING_USER);
  window.history.replaceState(null, '', `${window.location.pathname}?${search.toString()}`);
};
